import { Button, ButtonPropsColorOverrides } from '@mui/material';
interface IButtonFIleComponenteProps {
  accept: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  titulo: string;
  color?: ButtonPropsColorOverrides;
}

export default function ButtonFileComponente({
  onChange,
  accept,
  titulo,
}: Readonly<IButtonFIleComponenteProps>) {

  return (
    <>
      <input
        type="file"
        accept={accept}
        onChange={onChange}
        style={{ display: 'none' }}
        id={'upload-input-series-' + titulo}
        onClick={(e) => {
          // TS: e.currentTarget es HTMLInputElement
          e.currentTarget.value = '';
        }}
      />
      <label htmlFor={'upload-input-series-' + titulo}>
        <Button
          variant="contained"
          component="span"
          fullWidth
          size="small"
          style={{
            color: 'white',
            background: 'black'
          }}
        >
          {titulo}
        </Button>
      </label>
    </>
  );
}
